import {
  createContextBuilder,
  createItemState,
} from "~app/lib/context-builder";

// Navigation history state type
export interface NavigationHistoryState {
  previousPath: string | null;
  currentPath: string | null;
}

// Navigation history actions type (standard actions from context builder)
export interface NavigationHistoryActions {
  setPreviousPath: (path: string | null) => void;
  setCurrentPath: (path: string | null) => void;
}

// Create the navigation history context using context builder
export const {
  Provider: NavigationHistoryProvider,
  useContext: useNavigationHistory,
  useState: useNavigationHistoryState,
  useActions: useNavigationHistoryActions,
} = createContextBuilder<NavigationHistoryState, NavigationHistoryActions>({
  name: "NavigationHistory",
  state: {
    ...createItemState<string | null>("previousPath", null),
    ...createItemState<string | null>("currentPath", null),
  },
});
